<template>
    <div class="clearfix pb-3 px-0 ml-0">
        <!-- Abdullah chnaged class here . was clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3 -->
        <!-- Abdullah added this code here  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0" v-if="this.flg != 1">HR Settings<span>
                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / HR Settings / Work
                Locations</span>
        </h4>

        <b-alert v-model="hasDraft" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info"
            dismissible>There are some draft Work Locations.</b-alert>


        <div class="row mt-4" :class="{ 'no-margin': this.flg != 1 }"> <!-- Abdullah added this div  -->
            <div class="col-md-12 employee-table-wrapper" :class="{ 'ibox px-4': this.flg != 1 }">
                <!-- Abdullah chnaged the classes. was clearfix row py-2 mb-2 border-bottom and added 2nd class -->
                <div class="ibox-title dashboard_title px-0" v-if="this.flg != 1">
                    <!-- Abdullah chnaged class was here col-sm-5 px-3 company-form-box-title and added h4 and v-if -->
                    <h4>Work Locations</h4>
                </div>
                <div class="row"> <!-- Abdullah added this div  -->
                    <div class="col-md-6"> <!-- Abdullah chnaded class here. was col-sm-4  -->
                        <div class="custom-search w-100"> <!-- Abdullah removed class float-right  -->
                            <b-input-group class="mb-0">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search.." v-model="search"
                                    @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <div class=" col-md-6 text-right"> <!-- Abdullah chnaded class here. was col-sm-4 and pr-0  -->
                        <b-button id="show-btn" class="" v-if="permission >= 2" @click="addNew()"> Add Work
                            Location</b-button> <!-- Abdullah removed class mt-3 -->

                    </div>
                </div>

                <!-- Abdullah bring this table up. it was below next block of code  -->
                <div class="ibox-content px-0 mt-4">
                    <!-- Abdullah chnaged this class. it was col-sm-12  px-0 and removed  v-if="permission >= 0" -->
                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <!-- alpha fix- removed list table  -->
                        <table class="table border">
                            <thead>
                                <tr class="table-head">
                                    <td style="width: 60px;" class="">#SL</td>
                                    <!-- Abdullah chnaged this class. it was class="pl-5" added style and SL-->
                                    <!-- <td></td>  Abdullah Commented this -->
                                    <td>Name</td>
                                    <td>City</td>
                                    <td>Post Code</td>
                                    <td style="width: 100px;" v-if="permission >= 2" class="">Action</td>
                                    <!-- Abdullah added style="width: 100px; and removed class-->
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(branch, n) in paginatedData"
                                    :key="branch.id">
                                    <!-- alpha fix- removed class pl-5 and added tetx-center  -->
                                    <td class="text-center">{{ branch.index }}</td>

                                    <!-- Abdullah commented this  -->
                                    <!-- <td>
                                        <b-icon v-if="branch.draft_flg == 1" icon="pencil-square" v-b-tooltip.hover title="Has Draft Data"></b-icon>
                                    </td> -->
                                    <td class=" ">{{ branch.name }}</td>
                                    <td class=""><template v-if="branch.city != 'null' && branch.city != null">{{ branch.city }}</template><template v-else>N/A</template></td>
                                    <td class="">{{ branch.postcode || no_branches }}</td>


                                    <td class="float-right" v-if="permission >= 2">
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown"
                                                    class="dropdown-toggle clearfix action-dropdown-toggle"
                                                    style="font-size: 16px;" href="#" role="button"
                                                    data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"><b-icon
                                                        icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu"
                                                    aria-labelledby="actionDropdown">
                                                    <b-button-group class="mr-0">

                                                        <b-button variant="outline-secondary" title="Edit Work Location"
                                                            @click="editBranch(branch.id)">
                                                            <!-- Abdullah added variant="outline-secondary" and removed class -->
                                                            <b-icon icon="pencil" class="mr-2"
                                                                aria-hidden="true"></b-icon>Edit
                                                        </b-button>
                                                        <b-button v-if="permission == 2" variant="outline-secondary"
                                                            title="Delete Work Location"
                                                            @click="deleteBranch(branch.id)">
                                                            <!-- Abdullah added variant="outline-secondary" and removed class class="rounded delete-btn" -->
                                                            <b-icon icon="trash" class="mr-2"
                                                                aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="row py-2 no-margin"> <!-- Abdullah chnaged class. was class="px-3-->
                            <div class="col-md-12 p-0 no-margin"><!-- Abdullah added this div-->
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length"
                                            :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                                </ul>
                                <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                                    base-url="#" first-number last-number><template
                                        #prev-text><span>Previous</span></template><template
                                        #next-text><span>Next</span></template></b-pagination-nav>
                            </div>
                        </div>


                        <div v-if="this.flg == 1" class="mt-3">
                            <div class="text-center"> <!-- Abdullah added this div-->
                                <b-button type="button" @click="set_go_next(1)" variant="primary"
                                    class="btn-primary  mt-3 mr-3 d-none">Go
                                    Next</b-button> <!-- Abdullah chnaged class. it was float-right mt-3 mr-3-->
                                <b-button type="button" @click="set_go_back(1)" variant="primary"
                                    class="float-right mt-3 mr-3">Go
                                    Back</b-button> <!-- Abdullah chnaged class. it was float-right mt-3 mr-3-->
                                <b-button type="button" @click="setfinish(1)" variant="success"
                                    class="float-right mt-3 mx-3">Finish</b-button>
                                <!-- Abdullah chnaged class. it was float-right mt-3 mr-3-->
                            </div>
                        </div>

                    </b-overlay>


                </div>








            </div>
        </div>



        <div class="row justify-content-center">
            <div class="col-sm-12  px-0" v-if="permission >= 2">
                <b-modal id="bv-modal-branch" size="lg" hide-footer :title="department_details">
                    <!-- Abdullah echnaged title here. was Working Loaction details  -->
                    <b-overlay :show="showoverlay" rounded="sm">

                        <b-form @submit.stop.prevent="onSubmit" class="">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <div class="clearfix row">

                                <div class="col-md-6">
                                    <b-form-group id="name-group" label="Name"
                                        class="required-field all-rounded" label-for="name">
                                        <!-- Abdullah added class all-rounded  -->
                                        <b-input-group>
                                            <!-- // AbdullahALC chnaged added this code, added class radius-8 -->
                                            <b-form-input class="radius-8" id="name" name="name" v-model="fdata.name"
                                                v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                                aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                                }}</b-form-invalid-feedback>
                                            <b-input-group-append v-if="draft_data['name']" v-b-tooltip.hover
                                                :title="xdata['name']"><b-icon icon="pencil-square"
                                                    class="ml-1 mt-2"></b-icon></b-input-group-append>

                                        </b-input-group>
                                    </b-form-group>


                                    <b-form-group id="city-group" label="City" class="" label-for="city">
                                        <b-input-group>
                                            <b-form-input id="city" name="city" v-model="fdata.city" v-validate="{}"
                                                :state="validateState('city')" aria-describedby="city-feedback"
                                                data-vv-as="City"></b-form-input>
                                            <b-input-group-append v-if="draft_data['city']" v-b-tooltip.hover
                                                :title="xdata['city']"><b-icon icon="pencil-square"
                                                    class="ml-1 mt-2"></b-icon></b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group id="lat_long-group" label="Latitude Longitude" class=" radius-8" label-for="postcode">
                                        <b-input-group>
                                            <b-form-input id="lat_long" name="lat_long" v-model="fdata.lat_long" v-validate="{ regex: /^-?\d+\.?\d*,\s*-?\d+\.?\d*$/ }" :state="validateState('lat_long')" aria-describedby="lat_long-feedback" data-vv-as="Latitude Longitude" class="radius-8"></b-form-input>
                                            <b-input-group-append v-if="draft_data['lat_long']" v-b-tooltip.hover :title="xdata['lat_long']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>

                                            <b-form-invalid-feedback id="lat_long-feedback">
                                                    {{ veeErrors.first('lat_long') }}
                                            </b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>



                                </div>



                                <div class="col-md-6">
                                    <b-form-group id="address_line_1-group" label="Address" class=" "
                                        label-for="address_line_1" :style="veeErrors.has('name') ? 'margin-bottom: 39px' : ''">
                                        <b-input-group>
                                            <b-form-input id="address_line_1" name="address_line_1"
                                                v-model="fdata.address_line_1" v-validate="{}"
                                                :state="validateState('address_line_1')"
                                                aria-describedby="address_line_1-feedback"
                                                data-vv-as="Adress Line 1"></b-form-input>
                                            <b-input-group-append v-if="draft_data['address_line_1']" v-b-tooltip.hover
                                                :title="xdata['address_line_1']"><b-icon icon="pencil-square"
                                                    class="ml-1 mt-2"></b-icon></b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>



                                    <b-form-group id="postcode-group" label="Zip Code" class=" "
                                        label-for="postcode">
                                        <b-input-group>
                                            <!-- alpha fix- added radius 8 here  -->
                                            <b-form-input id="postcode" name="postcode" v-model="fdata.postcode" class="radius-8"
                                                v-validate="{numeric: true}" :state="validateState('postcode')"
                                                aria-describedby="postcode-feedback" data-vv-as="Post Code"></b-form-input>
                                            <b-input-group-append v-if="draft_data['postcode']" v-b-tooltip.hover
                                                :title="xdata['postcode']"><b-icon icon="pencil-square"
                                                    class="ml-1 mt-2"></b-icon></b-input-group-append>
                                        <b-form-invalid-feedback id="postcode-feedback">{{ veeErrors.first('postcode') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>

                                </div>

                                <div class="full-width">

                                    <template v-if="(Object.keys(draft_data).length > 0) && (permission == 2)">
                                        <div class="btn-wrapper text-center pt-5"> <!-- Abdullah added this div  -->
                                            <b-button type="submit" variant="primary">Approve</b-button>
                                            <!-- Abdullah chnaged variant to primary  -->
                                            <b-button v-if="(Object.keys(draft_data).length > 0) && (permission == 2)"
                                                @click="resetBranch(fdata.id)" type="button"
                                                variant="primary">Reset</b-button>
                                            <!-- Abdullah chnaged variant to primary  -->
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="btn-wrapper text-center pt-5"> <!-- Abdullah added this div  -->
                                            <!-- Abdullah after live chnaged this btn  -->
                                            <b-button class="btn-primary" type="submit" variant="primary">
                                                {{ is_edit_mode ? 'Update' : 'Submit' }}
                                            </b-button><!-- Abdullah chnaged variant to primary and chnaged btn name to Submit -->
                                        </div>
                                    </template>

                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>

                <b-modal id="bv-modal-branch-draft" size="lg" hide-footer title="Work Locations Details">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="saveDraftBranch">
                            <input type="hidden" v-model="draftdata.id" name="id">
                            <div class="clearfix row ">
                                <div class="col-md-6">
                                    <b-form-group id="name-group" label="Name" class="required-field "label-for="name">
                                        <b-input-group>
                                            <b-form-input id="name" name="name" v-model="draftdata.name"
                                                v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                                aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>

                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                                }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group id="city-group" label="City" class="" label-for="city">
                                        <b-input-group>
                                            <b-form-input id="city" name="city" v-model="draftdata.city" v-validate="{}"
                                                :state="validateState('city')" aria-describedby="city-feedback"
                                                data-vv-as="City"></b-form-input>

                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group id="lat_long-group" label="Latitude Longitude" class="" label-for="lat_long">
                                        <b-input-group>
                                            <b-form-input id="lat_long" name="lat_long" v-model="draftdata.lat_long" v-validate="{ regex: /^-?\d+\.?\d*,\s*-?\d+\.?\d*$/ }" :state="validateState('lat_long')" aria-describedby="lat_long-feedback" data-vv-as="Latitude Longitude"></b-form-input>
                                        </b-input-group>
                                        <b-form-invalid-feedback id="lat_long-feedback">
                                            {{ veeErrors.first('lat_long') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>


                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="address_line_1-group" label="Address" class=""label-for="address_line_1">
                                        <b-input-group>
                                            <b-form-input id="address_line_1" name="address_line_1"
                                                v-model="draftdata.address_line_1" v-validate="{}"
                                                :state="validateState('address_line_1')"
                                                aria-describedby="address_line_1-feedback"
                                                data-vv-as="Adress Line 1"></b-form-input>

                                        </b-input-group>
                                    </b-form-group>


                                    <b-form-group id="postcode-group" label="Zip Code" class=""
                                        label-for="postcode">
                                        <b-input-group>
                                            <b-form-input id="postcode" name="postcode" v-model="draftdata.postcode"
                                                v-validate="{numeric: true}" :state="validateState('postcode')"
                                                aria-describedby="postcode-feedback" data-vv-as="Post Code"></b-form-input>

                                        <b-form-invalid-feedback id="postcode-feedback">{{ veeErrors.first('postcode') }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>

                                </div>

                                <div class="full-width">
                                    <b-button type="submit" variant="success">Save</b-button>
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>



            <div class="col-sm-12  px-0 mt-5 reports-tab-nav" v-if="draft_branches.length > 0">
                <!-- Abdullah added calss here reports-tab-nav -->

                <div class="px-3 mb-2 company-form-box-title">New Work Locations (Waiting for Approval)</div>

                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table list-tables px-3 border"> <!-- Abdullah added calss here px-3-->
                        <thead>
                            <tr class="table-head">
                                <td class="pl-5">#</td>
                                <td>Name</td>
                                <td>City</td>
                                <td>Post Code</td>
                                <td v-if="permission >= 2" class="">Action</td> <!-- Abdullah removed class here-->
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(branch, n) in draft_branches"
                                :key="branch.id">
                                <td class="col-md-1 align-middle list-columns pl-5">{{ parseInt(n + 1) }}</td>
                                <td class=" ">{{ branch.name }}</td>
                                <td class="">{{ branch.city }}</td>
                                <td class="">{{ branch.postcode || no_branches }}</td>

                                <td class="clearfix col-md-6 align-middle" v-if="permission >= 2">
                                    <div class="float-right mr-2 position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">
                                                    <b-button v-if="permission == 2" class="mr-3 rounded edit-btn"
                                                        title="Approve Branch" @click="approveBranch(branch.id)">
                                                        <b-icon icon="check2" class="mr-2"
                                                            aria-hidden="true"></b-icon>Approve
                                                    </b-button>
                                                    <b-button class="mr-3 rounded edit-btn" title="Edit Branch"
                                                        @click="editDraftBranch(branch.id)">
                                                        <b-icon icon="pencil" class="mr-2"
                                                            aria-hidden="true"></b-icon>Edit
                                                    </b-button>
                                                    <b-button class="rounded delete-btn" title="Delete Branch"
                                                        @click="deleteDraftBranch(branch.id)">
                                                        <b-icon icon="trash" class="mr-2"
                                                            aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-overlay>
            </div>
        </div>

    </div>
</template>
<script>
export default {

    mounted() {
        this.permission = this.$acl['branch/details'];
    },
    props: ['flg'],
    data() {

        return {

            branches: [],
            draft_branches: [],
            divisions: [],
            districts: [],


            successmsg: false,
            warningmsg: false,
            dangermsg: false,

            showoverlay: false,
            showoverlay_list: false,
            go_back: false,
            go_next: false,
            finish: false,

            errormsg: [],

            // Abdullah Commented this line
            // fdata: { id:null , name:'' , division:'Dhaka' , district:null , address_line_1:'',address_line_2:'',city:'', postcode:'',lat_long:''},

            // Abdullah added this line
            fdata: { id: null, name: '', division: 'Dhaka', district: null, address_line_1: '', address_line_2: '', city: '', postcode: '' },
            xdata: {},
            draftdata: {},

            search: '',
            length: 20,
            temp_length: 20,
            people: 0,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            pagination: { currentPage: 1, pages: 1 },

            permission: 0,

            no_branches: 'N/A',

            hasDraft: false,
            draft_data: [],

            // Abdullah added this line
            department_details: 'Work Location Details',

            // <!-- Abdullah after live chnaged this  -->
            is_edit_mode: false,

        }
    },
    methods: {

        showMessage: function () {
            let tmp_flg = 0;
            if (this.branches.length > 0) tmp_flg = 1;
            let childdata = { flg: tmp_flg, successmsg: this.successmsg, warningmsg: this.warningmsg, dangermsg: this.dangermsg, move_next: this.go_next, move_back: this.go_back, finish: this.finish };
            this.$emit('childToParent', childdata);
        },
        set_go_back(x) {
            this.go_next = false;
            this.go_back = true;
            this.finish = false;

            if (x == 1)
                this.showMessage();
        },
        set_go_next(x) {
            this.go_next = true;
            this.go_back = false;
            this.finish = false;

            if (x == 1)
                this.showMessage();
        },
        disable_set_go_next() {
            this.go_next = false;
        },
        setfinish(x) {
            this.finish = true;

            this.go_next = false;
            this.go_back = false;

            if (x == 1)
                this.showMessage();
        },
        getDivisions: function () {
            axios.get(this.$api_url + '/divisions')
                .then(function (response) {
                    this.divisions = [{ value: null, text: "Select..." }].concat(response.data);
                }.bind(this));

            this.getDistricts();
        },
        getDistricts: function () {

            axios.get(this.$api_url + '/districts?d=' + this.fdata.division)
                .then(function (response) {
                    this.districts = [{ value: null, text: "Select..." }].concat(response.data);

                }.bind(this));

        },

        // Abdullah added this add new here
        addNew() {
            this.resetForm();
            this.department_details = 'Add Work Location';
            this.$bvModal.show('bv-modal-branch');
            //this.newagent = true;

            // <!-- Abdullah after live chnaged this  -->
            this.is_edit_mode = false;
        },

        getDraftBranchData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/branch/list/draft', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.draft_branches = response.data;

                if (this.draft_branches.length > 0)
                    this.hasDraft = true;
                else
                    this.hasDraft = false;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editDraftBranch: function (x) {
            this.addtype = false;
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.showoverlay = true;
            axios.get(this.$api_url + '/branch/details/draft', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.draftdata = response.data;
                this.$validator.reset();
                this.showoverlay = false;
                this.$bvModal.show('bv-modal-branch-draft');
            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });;
        },
        saveDraftBranch(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                let formData = new FormData();

                for (let [key, value] of Object.entries(this.draftdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/branch/save/draft', formData)
                    .then(function (response) {
                        this.getDraftBranchData();
                        this.successmsg = 'Saved!';
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        this.resetForm();
                        this.$bvModal.hide('bv-modal-branch-draft');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },
        deleteDraftBranch: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this draft work location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/branch/delete/draft', formData).then(function (response) {
                            this.getDraftBranchData();
                            this.$bvToast.toast('Deleted!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },

        approveBranch: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to approve this draft work location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/branch/approve/draft', formData).then(function (response) {

                            this.getBranchData();
                            this.getDraftBranchData();

                            this.$bvToast.toast('Approved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },
        resetBranch: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to reset this work location data.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        formData.append('type', 2);

                        axios.post(this.$api_url + '/clear/draft', formData).then(function (response) {

                            this.getBranchData();
                            this.editBranch(x);

                            this.$bvToast.toast('Saved', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },

        getDraftData: function (x) {

            if (!this.checkNet()) return false;
            this.hasDraft = false;
            let currentObj = this;
            let formData = new FormData();
            formData.append('id', x);
            formData.append('type', 2);

            axios.post(this.$api_url + '/cdata/draft', formData).then(function (response) {

                this.draft_data = response.data;
                if (this.draft_data.length > 0)
                    this.hasDraft = false;
                for (let [key, value] of Object.entries(this.draft_data)) {
                    this.fdata[key] = value;
                }

            }.bind(this));
        },


        getBranchData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/branch/list', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.branches = response.data;
                this.people = response.data.length;

                //this.showMessage();
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editBranch: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.warningmsg = null;
            this.successmsg = null;
            //this.showMessage();

            // Abdullah after live added this
            this.is_edit_mode = true;
            this.department_details = 'Edit Work Location';

            this.showoverlay = true;
            axios.get(this.$api_url + '/branch/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                //this.fdata = response.data;
                for (let [key, value] of Object.entries(response.data)) {
                    if (value == 'null') value = '';
                    this.xdata[key] = value;
                    this.fdata[key] = value;
                }


                this.$validator.reset();
                this.successmsg = null;
                this.showoverlay = false;

                this.getDraftData(x);

                this.$bvModal.show('bv-modal-branch');

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        deleteBranch(branch_id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this work location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        this.warningmsg = null;
                        this.successmsg = null;

                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', branch_id);

                        axios.post(this.$api_url + '/branch/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.branches = response.data.branches;

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            //this.showMessage();
                            this.showoverlay_list = false;
                            this.showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.showoverlay_list = false;
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', division: 'Dhaka', district: null, address_line_1: '', address_line_2: '', city: '', postcode: '' };


            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        // Abdullah after live commented this
        // addNew() {
        //     this.resetForm();
        //     this.$bvModal.show('bv-modal-branch');
        // },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;
            //this.showMessage();

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/branch/save', formData, config)
                    .then(function (response) {
                        this.getBranchData();
                        this.getDraftBranchData();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay_list = false;
                        this.showoverlay = false;
                        this.resetForm();
                        //this.movenext = true;
                        //this.showMessage();

                        this.$bvModal.hide('bv-modal-branch');

                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay_list = false;
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getBranchData();
        this.getDraftBranchData();
        this.getDivisions();
        Fire.$on('reloadUsers', () => { this.getBranchData() });
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.branches;
            if (this.search) {
                const search = this.search.toLowerCase();
                const searchableKeys = ['name', 'city', 'postcode']; // whatever columns are actually shown
                filtered_list = filtered_list.filter((row) => {
                    return searchableKeys.some((key) => {
                        return String(row[key] ?? '').toLowerCase().indexOf(search) > -1;
                    });
                });
            }
            return filtered_list;
        },
        paginatedData() {
            this.people = this.filteredData.length;
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>

<style scoped>
    .list-tables {
        border-collapse: collapse !important;

    }
</style>




